module.exports = __webpack_public_path__ + "img/undo-disabled.65eccbdc.svg";